exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item___30KjR {\n  padding: 12px 0;\n  border-bottom: 1px solid #d9d9d9;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n.itemTitle___5eYzV {\n  color: #21201f;\n  margin-left: 12px;\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 20px;\n  line-height: 1.42857143;\n  font-weight: 600;\n}\n.itemToggleWrapper___2uHPx {\n  justify-self: flex-end;\n}\n", ""]);

// exports
exports.locals = {
	"item": "item___30KjR",
	"itemTitle": "itemTitle___5eYzV",
	"itemToggleWrapper": "itemToggleWrapper___2uHPx"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/common/HidePagesModal/HidePagesModal.module.less
// module id = 2620
// module chunks = 68